import axios from 'axios';
import { aadConfig, getAccessToken } from '../aad';
import type { GoldDashboardData, GoldEstimateBenchmark, GoldPortfolioRollup } from '../dto/gold';
import apiProxy from './apiProxy';

export const getGoldDashboard = apiProxy(
  'getGoldDashboard',
  async (accountId: string): Promise<GoldDashboardData | undefined> => {
    await getAccessToken(aadConfig().projectScopes);
    const { data } = await axios.get<GoldDashboardData>(
      `${process.env.PROJECT_API}/gold/dashboard?accounts=${encodeURIComponent(accountId)}`,
    );
    return data;
  },
);

export const getGoldEstimateBenchmark = apiProxy(
  'getGoldEstimateBenchmark',
  async (accountId: string, projectId: string): Promise<GoldEstimateBenchmark | undefined> => {
    await getAccessToken(aadConfig().projectScopes);
    const { data } = await axios.get<GoldEstimateBenchmark>(
      `${process.env.PROJECT_API}/gold/estimate?accounts=${encodeURIComponent(accountId)}&projectId=${encodeURIComponent(projectId)}`,
    );
    return data;
  },
);

/**
 * The scoped portfolio cost rollup behind Portfolio Value and Cost Composition.
 *
 * Guarded by a flag rather than called optimistically: the endpoint is a separate
 * CcBE deployment, and a dashboard that fires a request which 404s on every load
 * is noise in the logs and a spinner that never resolves. `goldPortfolioRollup()`
 * says whether this environment has it.
 */
export const getGoldPortfolioRollup = apiProxy(
  'getGoldPortfolioRollup',
  async (accountId: string, officeId?: string | null): Promise<GoldPortfolioRollup | undefined> => {
    await getAccessToken(aadConfig().projectScopes);
    const q = [`accounts=${encodeURIComponent(accountId)}`];
    if (officeId) q.push(`office=${encodeURIComponent(officeId)}`);
    const { data } = await axios.get<GoldPortfolioRollup>(`${process.env.PROJECT_API}/gold/portfolio?${q.join('&')}`);
    return data;
  },
);
